<div class="login-new" id="reset-password-container">
       <div class="onboarding-progress-container" id="invite-employees-progress-container">
              <div class="onboarding-progress" id="invite-employees-progress-bar">
                     <span class="progress completed" id="progress-step-1"></span>
                     <span class="progress completed" id="progress-step-2"></span>
                     <span class="progress completed" id="progress-step-3"></span>
                     <span class="progress completed" id="progress-step-4"></span>
                     <span class="progress active" id="progress-step-5"></span>
              </div>
              <p id="progress-counter"><strong>5</strong> of 5</p>
       </div>
       <div id="invite-employees-header">
              <h5 class="onboarding-title" id="invite-employees-title">{{'invite_3_employees' | translate}}</h5>
              <ds-info-text class="warning-info-section"  [infoTextInput]="inviteInfoConfig"></ds-info-text>
       </div>
       <div id="invite-employees-form-container">
              <form class="from-invite-employee" id="invite-employees-form">
                     @if(invitedEmployees.length > 0){<div class="invite-employee-block" id="invited-employees-list">
                            @for(employee of invitedEmployees; track employee.id; let i = $index) {<div [id]="'invited-employee-' + i">
                                   @if(!employee.isExpanded){<div class="invite-employee-wrapper" [id]="'employee-collapsed-' + i">
                                          <div class="counter-data" [id]="'employee-counter-' + i">
                                                 <p [id]="'employee-number-' + i">{{ i + 1 }}.</p>
                                                 <p class="emp-data" [id]="'employee-data-' + i"><span class="emp-name" [id]="'employee-name-' + i">{{ employee.firstName }} {{ employee.lastName }}</span> <span class="emp-email" [id]="'employee-email-display-' + i">{{ employee.email }}</span></p>
                                          </div>
                                          <img [id]="'employee-edit-btn-' + i" [src]="ICONS.EDIT" alt="" (click)="toggleAccordion(i)">
                                   </div>}
                                   @if(employee.isExpanded){<div class="expanded-form one-col-grid input-no-margin" [id]="'employee-expanded-' + i">
                                          <div class="two-col-grid row-gap-0" [id]="'employee-name-fields-' + i">
                                                 <ds-textbox
                                                        [textboxInput]="firstAccnameConfig"
                                                        (valueChange)="onAccordionTextboxChange($event, 'firstName', i)"
                                                        (keypress)="allowAcuteCharFN($event)">
                                                 </ds-textbox>

                                                 <ds-textbox
                                                        [textboxInput]="lastaccnameConfig"
                                                        (valueChange)="onAccordionTextboxChange($event, 'lastName', i)"
                                                        (keypress)="allowAcuteCharLN($event)">
                                                 </ds-textbox>
                                          </div>
                                          <ds-textbox
                                                 [textboxInput]="emailaccConfig"
                                                 (valueChange)="onAccordionTextboxChange($event, 'email', i)">
                                          </ds-textbox>
                                   </div>}
                            </div>}
                     </div>}

                     @if(!isAnyAccordionExpanded() && invitedEmployees.length < 3){<div id="current-employee-form" class="one-col-grid input-no-margin">
                            <div class="two-col-grid row-gap-0" id="current-employee-name-fields">
                                   <ds-textbox
                                          [textboxInput]="firstnameConfig"
                                          (valueChange)="onCurrentChange($event, 'first-name')"
                                          (keypress)="allowAcuteCharFN($event)">
                                   </ds-textbox>

                                   <ds-textbox
                                          [textboxInput]="lastnameConfig"
                                          (valueChange)="onCurrentChange($event, 'last-name')"
                                          (keypress)="allowAcuteCharLN($event)">
                                   </ds-textbox>
                            </div>

                            <ds-textbox
                                   [textboxInput]="emailConfig"
                                   (valueChange)="onCurrentChange($event, 'email')">
                            </ds-textbox>
                     </div>}
              </form>
       </div>
       <div class="d-flex flex-column gap-3" id="invite-employees-action-buttons">
              @if(canInviteMore()){<ds-button
                     [buttonInput]="addEmployeeConfig"
                     (btnClick)="!isEnableInvite && onInviteEmployee()">
              </ds-button>}

              <ds-button
                     [buttonInput]="continueConfig"
                     (btnClick)="!IsInviteCanBeDisabled && OnInviteClick()">
              </ds-button>
       </div>
</div>
